export const UPDATE_FREE_DISTANCE = 'UPDATE_FREE_DISTANCE';

export const actionUpdateFreeDistance = payload => ({
    type: UPDATE_FREE_DISTANCE,
    payload: payload
})
